
<wiz-vgroup class="tile-shadow" width="100%" height="100%" gap="0">
  <wiz-vgroup #argsZone [visible]="!!data" width="100%" height="100%" class="tile-body tile-tile" 
  style="display: flex; flex-wrap: wrap; padding: 1px;">
      <freedata-tile-gridster width="100%" height="100%" [freedataValue]="data"
      [provider]="provider" 
      [widgets]="widgets" style="padding-bottom: 1px;"></freedata-tile-gridster>
  </wiz-vgroup>
</wiz-vgroup>

